var map = {
	"./icon_status_effect_bentimm.png": 7420,
	"./icon_status_effect_bleed.png": 8676,
	"./icon_status_effect_fire.png": 930,
	"./icon_status_effect_fortify.png": 2279,
	"./icon_status_effect_holy_light.png": 8384,
	"./icon_status_effect_hooked.png": 2038,
	"./icon_status_effect_ice.png": 8812,
	"./icon_status_effect_kairos.png": 3711,
	"./icon_status_effect_lex.png": 4144,
	"./icon_status_effect_light.png": 7550,
	"./icon_status_effect_marked.png": 8757,
	"./icon_status_effect_molt_chill.png": 3631,
	"./icon_status_effect_molt_heat.png": 5971,
	"./icon_status_effect_oj.png": 1218,
	"./icon_status_effect_poison.png": 6967,
	"./icon_status_effect_rocket.png": 5691,
	"./icon_status_effect_shadow.png": 9864,
	"./icon_status_effect_shock.png": 5720,
	"./icon_status_effect_slow.png": 882,
	"./icon_status_effect_sting.png": 3043,
	"./icon_status_effect_webbed.png": 2333
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 875;